<template>
  <section
    v-if="getIsSidebarHidden == false"
    class="sidebar"
    style="margin-top: 0rem; box-shadow: none; padding-bottom: 0%; padding-top: 0%;"
    :class="{
      hide: getIsSidebarHidden == true,
      show: getIsSidebarHidden == false,
    }"
  >
    <div class="allButtons">
      <div>
        <b-list-group>
          <b-list-group-item
           v-if="client == 'DibaCelina'"
            button
            style="border-bottom: 1px solid #DDE0E5 !important; height: 100px;"
          >
            <router-link
              to="/"
              style="background-color: white !important; border: none !important; padding: 10px;"
            >
              <img
                src="@/assets/images/SpimFashionLogo.svg"
                width="60px"
                height="60px"
                alt="test"
                class="image1"
              >
              <img
                src="@/assets/images/SpimFashionLogo.svg"
                height="60px"
                width="240px"
                alt="test"
                class="image2"
              >
            </router-link>
          </b-list-group-item>
          <!-- <b-list-group-item
            v-else-if="client == 'DonikaLoci'"
            button
            style="border-bottom: 1px solid #DDE0E5 !important; height: 60px;"
          >
            <router-link
              to="/"
              style="background-color: white !important;border: none !important;"
            >
              <img
                src="@/assets/images/DonikaLociBig.png"
                width="35px"
                alt="test"
                class="image1"
              >
              <img
                src="@/assets/images/DonikaLociWhiteSVG.svg"
                width="120px"
                alt="test"
                class="image2"
              >
            </router-link>
          </b-list-group-item> -->
          <b-list-group-item
            v-if="
              getLoggedInUser.role !== 'Sewer' &&
                getLoggedInUser.role !== 'Trainee' &&
                getLoggedInUser.role !== 'PatternMaker' &&
                getLoggedInUser.role !== 'StockManager' &&
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                getLoggedInUser.role !== 'OnlineSales' &&
                getLoggedInUser.role !== 'Designer' &&
                getLoggedInUser.role !== 'SalesPerson' &&
                getLoggedInUser.role !== 'HRFinance' &&
                getLoggedInUser.role !== 'Security' &&
                getLoggedInUser.role !== 'Chauffer' &&
                getLoggedInUser.role !== 'CleaningPerson' &&
                getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                getLoggedInUser.role !== 'Deliverer' &&
                getLoggedInUser.role !== 'TeamLeaderPattern' &&
                getLoggedInUser.role !== 'Procurement'
            "
            button
          >
            <router-link
              to="/"
              @click.native="clickLink"
            >
              <img
                src="@/assets/images/dashboard.svg"
                alt="test"
              >
              <p>{{ $t("Dashboard") }}</p>
            </router-link>
          </b-list-group-item>
          <b-list-group-item
            v-if="
              getLoggedInUser.role !== 'Deliverer' &&
                getLoggedInUser.role !== 'TeamLeader' &&
                getLoggedInUser.role !== 'Sewer' &&
                getLoggedInUser.role !== 'Trainee' &&
                getLoggedInUser.role !== 'PatternMaker' &&
                getLoggedInUser.role !== 'StockManager' &&
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                getLoggedInUser.role !== 'Accountant' &&
                getLoggedInUser.role !== 'HR' &&
                getLoggedInUser.role !== 'HRFinance' &&
                getLoggedInUser.role !== 'Security' &&
                getLoggedInUser.role !== 'Chauffer' &&
                getLoggedInUser.role !== 'CleaningPerson' &&
                getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                getLoggedInUser.role !== 'Deliverer' &&
                getLoggedInUser.role !== 'TeamLeaderPattern' &&
                getLoggedInUser.role !== 'Procurement'
            "
            v-b-toggle.collapse-88
            button
            @click="reset"
          >
            <router-link
              to="/create-order-dashboard"
              :class="{ 'active' : $route.path === '/sell-products' || $route.path === '/create-order'}"
            >
              <img
                src="@/assets/images/createorder.svg"
                width="30px"
                alt="test"
              >
              <p>{{ $t("Storefront") }}</p>
            </router-link>
            <div class="collapse-icon">
              <b-icon-chevron-down />
            </div>
          </b-list-group-item>
          <b-collapse
            id="collapse-88"
            class="mt-2"
            accordion="my-accordion"
          >
            <b-list-group-item
              button
              @click="resetTotalStock"
            >
              <router-link
                to="/create-order"
                @click.native="clickLink"
              >
                <p>{{ $t("CreateOrder") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              button
            >
              <router-link
                to="/sell-products"
                @click.native="clickLink"
              >
                <p>{{ $t("SellProductsFromStock") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              button
              v-b-modal.scan-and-sell
              @click="openScanAndSellModal"
            >
              <router-link
                to="#"
                @click.native="clickLink"
              >
                <p>{{ $t("ScanAndSell") }}</p>
              </router-link>
            </b-list-group-item>
          </b-collapse>
          <!--          <b-list-group-item-->
          <!--            v-if="-->
          <!--              getLoggedInUser.role !== 'Deliverer' &&-->
          <!--                getLoggedInUser.role !== 'TeamLeader' &&-->
          <!--                getLoggedInUser.role !== 'Sewer' &&-->
          <!--                getLoggedInUser.role !== 'Trainee' &&-->
          <!--                getLoggedInUser.role !== 'PatternMaker' &&-->
          <!--                getLoggedInUser.role !== 'StockManager' &&-->
          <!--                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&-->
          <!--                getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&-->
          <!--                getLoggedInUser.role !== 'Accountant' &&-->
          <!--                getLoggedInUser.role !== 'HR' &&-->
          <!--                getLoggedInUser.role !== 'HRFinance' &&-->
          <!--                getLoggedInUser.role !== 'Security' &&-->
          <!--                getLoggedInUser.role !== 'Chauffer' &&-->
          <!--                getLoggedInUser.role !== 'CleaningPerson' &&-->
          <!--                getLoggedInUser.role !== 'StockManagerWarehousProductions' &&-->
          <!--                getLoggedInUser.role !== 'Deliverer' &&-->
          <!--                getLoggedInUser.role !== 'TeamLeaderPattern'-->
          <!--            "-->
          <!--            v-b-toggle.collapse-126-->
          <!--            button-->
          <!--          >-->
          <!--            <router-link-->
          <!--              to="/create-fabric-dashboard"-->
          <!--              :class="{ 'active' : $route.path === '/create-order-nominative' || $route.path === '/return-process-materials' || $route.path === '/internal-moving-materials' || $route.path === '/orders-nominative' || $route.path === '/materials-management' || $route.path === '/materials-overview' || $route.path === '/selling-report'}"-->
          <!--            >-->
          <!--              <img-->
          <!--                src="@/assets/images/material.svg"-->
          <!--                width="30px"-->
          <!--                alt="test"-->
          <!--              >-->
          <!--              <p>{{ $t("CreateFabricOrder") }}</p>-->
          <!--            </router-link>-->
          <!--            <div class="collapse-icon">-->
          <!--              <b-icon-chevron-down />-->
          <!--            </div>-->
          <!--          </b-list-group-item>-->
          <b-collapse
            id="collapse-126"
            class="mt-2"
            accordion="my-accordion"
          >
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'Sewer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'StockManager' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                  getLoggedInUser.role !== 'Accountant' &&
                  getLoggedInUser.role !== 'HR' &&
                  getLoggedInUser.role !== 'HRFinance' &&
                  getLoggedInUser.role !== 'Security' &&
                  getLoggedInUser.role !== 'Chauffer' &&
                  getLoggedInUser.role !== 'CleaningPerson' &&
                  getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                  getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeaderPattern' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
              @click="reset"
            >
              <router-link
                to="/create-order-nominative"
                @click.native="clickLink"
              >
                <!-- <b-icon-folder /> -->


                <p>{{ $t("SellFabric") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'Sewer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'StockManager' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                  getLoggedInUser.role !== 'Accountant' &&
                  getLoggedInUser.role !== 'Security' &&
                  getLoggedInUser.role !== 'Chauffer' &&
                  getLoggedInUser.role !== 'CleaningPerson' &&
                  getLoggedInUser.role !== 'HR' &&
                  getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                  getLoggedInUser.role !== 'HRFinance' &&
                  getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeaderPattern' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
              @click="reset"
            >
              <router-link
                to="/orders-nominative"
                @click.native="clickLink"
              >
                <!-- <b-icon-folder /> -->


                <p>{{ $t("FabricOrders") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'Sewer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'StockManager' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                  getLoggedInUser.role !== 'Accountant' &&
                  getLoggedInUser.role !== 'Security' &&
                  getLoggedInUser.role !== 'Chauffer' &&
                  getLoggedInUser.role !== 'CleaningPerson' &&
                  getLoggedInUser.role !== 'HR' &&
                  getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                  getLoggedInUser.role !== 'HRFinance' &&
                  getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeaderPattern' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
              @click="reset"
            >
              <router-link
                to="/materials-overview"
                @click.native="clickLink"
              >
                <!-- <b-icon-folder /> -->


                <p>{{ $t("MaterialsOverview") }}</p>
              </router-link>
            </b-list-group-item>

            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'Sewer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'StockManager' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                  getLoggedInUser.role !== 'Accountant' &&
                  getLoggedInUser.role !== 'Security' &&
                  getLoggedInUser.role !== 'Chauffer' &&
                  getLoggedInUser.role !== 'CleaningPerson' &&
                  getLoggedInUser.role !== 'HR' &&
                  getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                  getLoggedInUser.role !== 'HRFinance' &&
                  getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeaderPattern' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
            >
              <router-link
                to="/materials-management"
                @click.native="clickLink"
              >
                <!-- <b-icon-folder /> -->


                <p>{{ $t("MaterialsManagement") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'Sewer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'StockManager' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                  getLoggedInUser.role !== 'Accountant' &&
                  getLoggedInUser.role !== 'Security' &&
                  getLoggedInUser.role !== 'Chauffer' &&
                  getLoggedInUser.role !== 'CleaningPerson' &&
                  getLoggedInUser.role !== 'HR' &&
                  getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                  getLoggedInUser.role !== 'HRFinance' &&
                  getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeaderPattern' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
            >
              <router-link
                to="/selling-report"
                @click.native="clickLink"
              >
                <!-- <b-icon-folder /> -->


                <p>{{ $t("SellingReport") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              button
              @click="resetInternal"
            >
              <router-link
                to="/internal-moving-materials"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("InternalMoving") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role == 'CEO' ||
                  getLoggedInUser.role == 'Admin' ||
                  getLoggedInUser.role == 'Manager'
              "
              button
            >
              <router-link
                to="/admin-material"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("AdminAuthorise") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              button
            >
              <router-link
                to="/return-process-materials"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("ReturnToStock") }}
                </p>
              </router-link>
            </b-list-group-item>
          </b-collapse>
          <b-list-group-item
            v-if="
              getLoggedInUser.role !== 'Sewer' &&
                getLoggedInUser.role !== 'Trainee' &&
                getLoggedInUser.role !== 'PatternMaker' &&
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                getLoggedInUser.role !== 'HRFinance' &&
                getLoggedInUser.role !== 'Security' &&
                getLoggedInUser.role !== 'Chauffer' &&
                getLoggedInUser.role !== 'CleaningPerson' &&
                getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                getLoggedInUser.role !== 'Deliverer'
            "
            v-b-toggle.collapse-12
            button
          >
            <router-link
              to="/orders-management-dashboard"
              :class="{ 'active' : $route.path === '/orders-management' || $route.path === '/new-orders-edit' || $route.path === '/production-management' || $route.path === '/order-item-tracking' || $route.path === '/admin' || $route.path === '/deliverer-orders-management/ReadyToDeliver' || $route.path === '/orders-overview/ReadyToDeliver' || $route.path === '/orders-overview/Assigned' || $route.path === '/orders-overview/all' || $route.path === '/order-item-tracking' || $route.path === '/selling' || $route.path === '/return-process' || $route.path === '/internal-moving'}"
            >
              <img
                src="@/assets/images/ordermanagement.svg"
                alt="test"
              >
              <p>{{ $t("OrdersManagement") }}</p>
            </router-link>
            <div class="collapse-icon">
              <b-icon-chevron-down />
            </div>
          </b-list-group-item>

          <b-collapse
            id="collapse-12"
            class="mt-2"
            accordion="my-accordion"
          >
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'SalesPerson' &&
                  getLoggedInUser.role !== 'Designer' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'StockManager' &&
                  getLoggedInUser.role !== 'Accountant' &&
                  getLoggedInUser.role !== 'HR' &&
                  getLoggedInUser.role !== 'OnlineSales' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
              @click="resetCreatedOrdersByOrderNumber"
            >
              <router-link
                to="/orders-management"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("NewOrders") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role == 'CEO' ||
                  getLoggedInUser.role == 'Admin' ||
                  getLoggedInUser.role == 'Manager' ||
                  getLoggedInUser.role == 'TeamLeader' ||
                  getLoggedInUser.role == 'TeamLeaderPattern' ||
                  getLoggedInUser.role == 'Procurement'
              "
              button
              @click="reset"
            >
              <router-link
                to="/new-orders-edit"
                @click.native="clickLink"
              >
                <!-- <b-icon-folder /> -->


                <p>{{ $t("EditNewOrders") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'SalesPerson' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'Designer' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'StockManager' &&
                  getLoggedInUser.role !== 'Receptionist' &&
                  getLoggedInUser.role !== 'Accountant' &&
                  getLoggedInUser.role !== 'HR' &&
                  getLoggedInUser.role !== 'OnlineSales' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
            >
              <router-link
                to="/production-management"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("ProductionManagement") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role == 'Deliverer' &&
                  getLoggedInUser.role !== 'SalesPerson' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'Accountant' &&
                  getLoggedInUser.role !== 'HR' &&
                  getLoggedInUser.role !== 'OnlineSales' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
            >
              <router-link
                to="/deliverer-orders-management/ReadyToDeliver"
                @click.native="clickLink"
              >
                {{ $t('DelivererOrdersManagement') }}
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
            >
              <router-link
                :to="
                  getLoggedInUser.role == 'Deliverer'
                    ? '/orders-overview/ReadyToDeliver'
                    : getLoggedInUser.role == 'TeamLeader'
                      ? '/orders-overview/Assigned'
                      : '/orders-overview/all'
                "
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("OrdersOverview") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'Sewer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'StockManager' &&
                  getLoggedInUser.role !== 'SalesPerson' &&
                  getLoggedInUser.role !== 'Designer' &&
                  getLoggedInUser.role !== 'Receptionist' &&
                  getLoggedInUser.role !== 'Accountant' &&
                  getLoggedInUser.role !== 'HR' &&
                  getLoggedInUser.role !== 'OnlineSales' &&
                  getLoggedInUser.role !== 'TeamLeaderPattern' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
            >
              <router-link
                to="/order-item-tracking"
                @click.native="clickLink"
              >
                <!-- <img
                src="@/assets/images/9. Order Item Tracking (1).svg"
                width="40px"
                alt="test"
              > -->
                <p>{{ $t("OrderItemTracking") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role == 'CEO' ||
                  getLoggedInUser.role == 'Admin' ||
                  getLoggedInUser.role == 'Manager'
              "
              button
            >
              <router-link
                to="/admin"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("AdminAuthorise") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role == 'CEO' ||
                  getLoggedInUser.role == 'Admin'||
                  getLoggedInUser.role == 'Receptionist'
              "
              button
            >
              <router-link
                to="/selling"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("SellingReport") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="getLoggedInUser.role !== 'Procurement'"
              button
              @click="resetInternal"
            >
              <router-link
                to="/internal-moving"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("InternalMoving") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="getLoggedInUser.role !== 'Procurement'"
              button
              @click="resetInternal"
            >
              <router-link
                to="/return-process"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("ReturnToStock") }}
                </p>
              </router-link>
            </b-list-group-item>
          </b-collapse>

          <b-list-group-item
            v-if="
              getLoggedInUser.role !== 'Deliverer' &&
                getLoggedInUser.role !== 'Trainee' &&
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                getLoggedInUser.role !== 'SalesPerson' &&
                getLoggedInUser.role !== 'PatternMaker' &&
                getLoggedInUser.role !== 'StockManager' &&
                getLoggedInUser.role !== 'HR' &&
                getLoggedInUser.role !== 'HRFinance' &&
                getLoggedInUser.role !== 'Security' &&
                getLoggedInUser.role !== 'Chauffer' &&
                getLoggedInUser.role !== 'CleaningPerson' &&
                getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                getLoggedInUser.role !== 'TeamLeader' &&
                getLoggedInUser.role !== 'Accountant' &&
                getLoggedInUser.role !== 'Deliverer' &&
                getLoggedInUser.role !== 'TeamLeaderPattern'
            "
            v-b-toggle.collapse-3
            button
          >
            <router-link
              to="/products-dashboard"
              :class="{ 'active' : $route.path === '/products' || $route.path === '/product-reporting' || $route.path === '/product-configuration'}"
            >
              <img
                src="@/assets/images/products.svg"
                alt="test"
              >
              <p>{{ $t("Products1") }}</p>
            </router-link>
            <div class="collapse-icon">
              <b-icon-chevron-down />
            </div>
          </b-list-group-item>
          <b-collapse
            id="collapse-3"
            class="mt-2"
            accordion="my-accordion"
          >
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Sewer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'SalesPerson' &&
                  getLoggedInUser.role !== 'Accountant' &&
                  getLoggedInUser.role !== 'ExecutiveAssitant'
              "
              button
              @click="reset"
            >
              <router-link
                to="/products"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("ProductManagement") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item button>
              <router-link
                to="/product-reporting"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("ProductReporting") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item button>
              <router-link
                to="/product-configuration"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("ConfigurationsProducts") }}
                </p>
              </router-link>
            </b-list-group-item>
          </b-collapse>
          <b-list-group-item
            v-if="getLoggedInUser.role !== 'StockManagerMaterialVariant' && getLoggedInUser.role !== 'Sewer'
              && getLoggedInUser.role !== 'PatternMaker' &&
              getLoggedInUser.role !== 'Accountant'&&
              getLoggedInUser.role !== 'StockManager' &&
              client != 'DrenushaXharra' &&
              getLoggedInUser.role !== 'HR' &&
              getLoggedInUser.role !== 'HRFinance' &&
              getLoggedInUser.role !== 'Security' &&
              getLoggedInUser.role !== 'Chauffer' &&
              getLoggedInUser.role !== 'CleaningPerson' &&
              getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
              getLoggedInUser.role !== 'Manager' &&
              getLoggedInUser.role !== 'TeamLeader' &&
              getLoggedInUser.role !== 'Deliverer' &&
              getLoggedInUser.role !== 'TeamLeaderPattern' &&
              getLoggedInUser.role !== 'Procurement'"
            v-b-toggle.collapse-7
            button
          >
            <router-link
              to="/status-in-stock"
              :class="{ 'active' : $route.path === '/status-in-stock' || $route.path === '/product-in-stock' || $route.path === '/products-in-stock' || $route.path === '/product-management-in-stock' || $route.path === '/product-overview-in-stock' || $route.path === '/product-in-stock-track-trace' || $route.path === '/products-stock' || $route.path === '/internal-moving-stock'}"
            >
              <!-- <b-icon icon="view-stacked" /> -->
              <img
                src="@/assets/images/stock.svg"
                alt="test"
              >
              <p>{{ $t("StockinStore") }}</p>
            </router-link>
            <div class="collapse-icon">
              <b-icon-chevron-down />
            </div>
          </b-list-group-item>
          <b-collapse
            id="collapse-7"
            class="mt-2"
            accordion="my-accordion"
          >
            <!-- <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Designer' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'OnlineSales'

              "
              button
            >
              <router-link
                to="/status-in-stock"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("Merchproductionstatus") }}
                </p>
              </router-link>
            </b-list-group-item> -->
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'Sewer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'StockManager' &&
                  getLoggedInUser.role !== 'Designer' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'OnlineSales' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
            >
              <router-link
                to="/product-in-stock"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("Productionmerch") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
            >
              <router-link
                to="/products-in-stock"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("MerchInStore") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'SalesPerson' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
              @click="resetTotalStock"
            >
              <router-link
                to="/products-stock"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("ProductsInStock") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
            >
              <router-link
                to="/product-management-in-stock"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("Merchproductionoverview") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="false"
              button
            >
              <router-link
                to="/product-overview-in-stock"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("ProductOverviewInStock") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'SalesPerson' &&
                  getLoggedInUser.role !== 'Designer' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'OnlineSales' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
            >
              <router-link
                to="/product-in-stock-track-trace"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("Merchproductiontracking") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'SalesPerson' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
              @click="resetInternal"
            >
              <router-link
                to="/internal-moving-stock"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("InternalMoving") }}
                </p>
              </router-link>
            </b-list-group-item>
          </b-collapse>
          <b-list-group-item
            v-if="getLoggedInUser.role !== 'Deliverer' && getLoggedInUser.role !== 'Receptionist' && getLoggedInUser.role !== 'StockManager' &&
              getLoggedInUser.role !== 'HRFinance' &&
              getLoggedInUser.role !== 'Security' &&
              getLoggedInUser.role !== 'Chauffer' &&
              getLoggedInUser.role !== 'CleaningPerson' &&
              getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
              getLoggedInUser.role !== 'Deliverer'"
            v-b-toggle.collapse-2
            button
          >
            <router-link
              to="/nowhere"
              class="disabled-link"
              :class="{ 'active' : $route.path === '/inventory' || $route.path === '/inventory-reporting' || $route.path === '/inventory-overview' || $route.path === '/material-colors' || $route.path === '/cart'}"
            >
              <img
                src="@/assets/images/material.svg"
                alt="test"
              >
              <p>{{ $t('Inventory') }}</p>
            </router-link>
            <div class="collapse-icon">
              <b-icon-chevron-down />
            </div>
          </b-list-group-item>
          <b-collapse
            id="collapse-2"
            class="mt-2"
            role="tabpanel"
            accordion="my-accordion"
          >
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'TeamLeaderPattern' &&
                  getLoggedInUser.role !== 'Sewer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'OnlineSales' &&
                  getLoggedInUser.role !== 'Designer' &&
                  getLoggedInUser.role !== 'SalesPerson' &&
                  getLoggedInUser.role !== 'Receptionist' &&
                  getLoggedInUser.role !== 'ExecutiveAssitant' &&
                  getLoggedInUser.role !== 'HR' &&
                  getLoggedInUser.role !== 'Accountant'

              "
              button
            >
              <router-link
                to="/inventory"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("InventoryManagement") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="getLoggedInUser.role !== 'OnlineSales' &&
                getLoggedInUser.role !== 'Designer' &&
                getLoggedInUser.role !== 'TeamLeader' &&
                getLoggedInUser.role !== 'TeamLeaderPattern' &&
                getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                getLoggedInUser.role !== 'HR' &&
                getLoggedInUser.role !== 'Accountant' &&
                getLoggedInUser.role !== 'Procurement'
              "
              button
            >
              <router-link
                to="/inventory-reporting"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("InventoryReporting") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Receptionist'"
              button
            >
              <router-link
                to="/inventory-overview"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("InventoryOverview") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="getLoggedInUser.role !== 'OnlineSales' &&
                getLoggedInUser.role !== 'TeamLeader' &&
                getLoggedInUser.role !== 'TeamLeaderPattern' &&
                getLoggedInUser.role !== 'SalesPerson' &&
                getLoggedInUser.role !== 'Receptionist' &&
                getLoggedInUser.role !== 'Accountant' &&
                getLoggedInUser.role !== 'HR'"
              button
            >
              <router-link
                to="/material-colors"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("MaterialColors") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="getLoggedInUser.role !== 'OnlineSales' &&
                getLoggedInUser.role !== 'Designer' &&
                getLoggedInUser.role !== 'SalesPerson' &&
                getLoggedInUser.role !== 'Receptionist' &&
                getLoggedInUser.role !== 'ExecutiveAssitant' &&
                getLoggedInUser.role !== 'Accountant' &&
                getLoggedInUser.role !== 'TeamLeader' &&
                getLoggedInUser.role !== 'TeamLeaderPattern' &&
                getLoggedInUser.role !== 'HR'"
              button
            >
              <router-link
                to="/cart"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("Cart") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'TeamLeaderPattern' &&
                  getLoggedInUser.role !== 'Sewer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'OnlineSales' &&
                  getLoggedInUser.role !== 'Designer' &&
                  getLoggedInUser.role !== 'SalesPerson' &&
                  getLoggedInUser.role !== 'Receptionist'
              "
              button
              @click="resetBuy"
            >
              <router-link
                to="/buy-direct"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("BuyDirect") }}
                </p>
              </router-link>
            </b-list-group-item>
          </b-collapse>

          <b-list-group-item
            v-if="
              getLoggedInUser.role !== 'Deliverer' &&
                getLoggedInUser.role !== 'Sewer' &&
                getLoggedInUser.role !== 'Trainee' &&
                getLoggedInUser.role !== 'PatternMaker' &&
                getLoggedInUser.role !== 'StockManager' &&
                getLoggedInUser.role !== 'OnlineSales' &&
                getLoggedInUser.role !== 'Designer' &&
                getLoggedInUser.role !== 'SalesPerson' &&
                getLoggedInUser.role !== 'Receptionist' &&
                getLoggedInUser.role !== 'Accountant' &&
                getLoggedInUser.role !== 'Security' &&
                getLoggedInUser.role !== 'Chauffer' &&
                getLoggedInUser.role !== 'CleaningPerson' &&
                getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                getLoggedInUser.role !== 'Deliverer' &&
                getLoggedInUser.role !== 'TeamLeaderPattern'
            "
            v-b-toggle.collapse-4
            button
          >
            <router-link
              to="/hr-dashboard"
              :class="{ 'active' : $route.path === '/teams' || $route.path === '/users' || $route.path === '/leave-request' || $route.path === '/calendar' || $route.path === '/employee-feedback' || $route.path === '/bankholidays'}"
            >
              <img
                src="@/assets/images/teams.svg"
                width="30px"
                alt="test"
              >
              <p>{{ $t("HumanResources") }}</p>
            </router-link>
            <div class="collapse-icon">
              <b-icon-chevron-down />
            </div>
          </b-list-group-item>
          <b-collapse
            id="collapse-4"
            class="mt-2"
            accordion="my-accordion"
          >
            <b-list-group-item
              button
            >
              <router-link
                to="/teams"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("TeamsManagement") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="getLoggedInUser.role !== 'TeamLeader' &&
                getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                getLoggedInUser.role !== 'ExecutiveAssitant' &&
                getLoggedInUser.role !== 'Procurement'"
              button
            >
              <router-link
                to="/users"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("EmployeeManagement") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="getLoggedInUser.role !== 'TeamLeader' &&
                getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                getLoggedInUser.role !== 'ExecutiveAssitant' &&
                getLoggedInUser.role !== 'Procurement'"
              button
            >
              <router-link
                to="/leave-request"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("VacationManagement") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role == 'Manager' ||
                  getLoggedInUser.role == 'CEO' ||
                  getLoggedInUser.role == 'Admin' ||
                  getLoggedInUser.role == 'ExecutiveAssitant'||
                  getLoggedInUser.role == 'HRFinance' ||
                  getLoggedInUser.role == 'HR' ||
                  getLoggedInUser.role == 'Accountant'"
              button
            >
              <router-link
                to="/calendar"
                @click.native="clickLink"
              >
                <p>{{ $t("VacationPlan") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role == 'Manager' ||
                  getLoggedInUser.role == 'CEO' ||
                  getLoggedInUser.role == 'Admin' ||
                  getLoggedInUser.role == 'HRFinance' ||
                  getLoggedInUser.role == 'HR' ||
                  getLoggedInUser.role == 'Accountant'
              "
              button
            >
              <router-link
                to="/employee-feedback"
                @click.native="clickLink"
              >
                <p>{{ $t("Feedback") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="getLoggedInUser.role !== 'TeamLeader' &&
                getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                getLoggedInUser.role !== 'ExecutiveAssitant' &&
                getLoggedInUser.role !== 'Procurement'"
              button
            >
              <router-link
                to="/bankholidays"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("BankHolidays") }}
                </p>
              </router-link>
            </b-list-group-item>
          </b-collapse>
          <b-list-group-item
            v-if="getLoggedInUser.role == 'CEO' || getLoggedInUser.role == 'Admin' || getLoggedInUser.role == 'HRFinance' || getLoggedInUser.role == 'HR'"
            v-b-toggle.collapse-8
            button
          >
            <router-link
              to="/finance-dashboard"
              :class="{ 'active' : $route.path === '/employee-payments' || $route.path === '/finance-account' || $route.path === '/finance-report' }"
            >

              <img
                src="@/assets/images/finance.svg"
                alt="test"
              >
              <p>{{ $t("Finance") }}</p>
            </router-link>
            <div class="collapse-icon">
              <b-icon-chevron-down />
            </div>
          </b-list-group-item>
          <b-collapse
            id="collapse-8"
            class="mt-2"
            accordion="my-accordion"
          >

            <b-list-group-item
              v-if="getLoggedInUser.role != 'HR'"
              button
            >
              <router-link
                to="/finance-report"
                @click.native="clickLink"
              >

                <p>{{ $t("FinancialReport") }}</p>
              </router-link>
            </b-list-group-item>

            <b-list-group-item
              button
            >
              <router-link
                to="/employee-payments"
                @click.native="clickLink"
              >

                <p>{{ $t("Salary") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="getLoggedInUser.role != 'HR'"
              button
            >
              <router-link
                to="/finance-account"
                @click.native="clickLink"
              >

                <p>{{ $t("Configurations") }}</p>
              </router-link>
            </b-list-group-item>
          </b-collapse>
          <b-list-group-item
            v-if="
              client != 'DrenushaXharra' &&
                getLoggedInUser.role !== 'Accountant' &&
                getLoggedInUser.role !== 'HR' &&
                getLoggedInUser.role !== 'HRFinance' &&
                getLoggedInUser.role !== 'Security' &&
                getLoggedInUser.role !== 'Chauffer' &&
                getLoggedInUser.role !== 'CleaningPerson' &&
                getLoggedInUser.role !== 'Deliverer' &&
                getLoggedInUser.role !== 'TeamLeaderPattern' &&
                getLoggedInUser.role !== 'Procurement'"
            v-b-toggle.collapse-13
            button
          >
            <router-link
              to="/warehouse-dashboard"
              :class="{ 'active' : $route.path === '/location' || $route.path === '/order-item-location' || $route.path === '/product-in-stock-location' || $route.path === '/material-variant-location'}"
            >

              <img
                src="@/assets/images/warehouses.svg"
                alt="test"
              >
              <p>{{ $t("WareHouse") }}</p>
            </router-link>
            <div class="collapse-icon">
              <b-icon-chevron-down />
            </div>
          </b-list-group-item>
          <b-collapse
            id="collapse-13"
            class="mt-2"
            accordion="my-accordion"
          >
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                  getLoggedInUser.role !== 'SalesPerson' &&
                  getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                  getLoggedInUser.role !== 'Receptionist' &&
                  getLoggedInUser.role !== 'Manager' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  getLoggedInUser.role !== 'StockManager' &&
                  getLoggedInUser.role !== 'Procurement'"
              button
            >
              <router-link
                to="/location"
                @click.native="clickLink"
              >


                <p>{{ $t("Location") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'Deliverer' &&
                  getLoggedInUser.role !== 'Sewer' &&
                  getLoggedInUser.role !== 'Trainee' &&
                  getLoggedInUser.role !== 'PatternMaker' &&
                  getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                  getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                  getLoggedInUser.role !== 'SalesPerson' && client != 'DrenushaXharra' &&
                  getLoggedInUser.role !== 'Procurement'
              "
              button
            >
              <router-link
                to="/order-item-location"
                @click.native="clickLink"
              >
                <p>{{ $t("OrderItemLocation") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                (getLoggedInUser.role == 'Receptionist' ||
                  getLoggedInUser.role == 'TeamLeader' ||
                  getLoggedInUser.role == 'Manager' ||
                  getLoggedInUser.role == 'CEO' ||
                  getLoggedInUser.role != 'StockManagerMaterialAndProduct' ||
                  getLoggedInUser.role != 'StockManagerMaterialVariant' ||
                  getLoggedInUser.role !== 'Procurement' ||
                  getLoggedInUser.role == 'Admin') && client != 'DrenushaXharra' && getLoggedInUser.role !== 'StockManagerWarehousProductions' && getLoggedInUser.role != 'SalesPerson'
              "
              button
            >
              <router-link
                to="/product-in-stock-location"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("ProductOverviewInStock") }}
                </p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role !== 'StockManager' &&
                  getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                  getLoggedInUser.role !== 'Receptionist' &&
                  getLoggedInUser.role !== 'TeamLeader' &&
                  client != 'DrenushaXharra'"
              button
            >
              <router-link
                to="/material-variant-location"
                @click.native="clickLink"
              >
                <p class="card-text">
                  {{ $t("MaterialVariantLocation") }}
                </p>
              </router-link>
            </b-list-group-item>
          </b-collapse>
          <b-list-group-item
            v-if="
              getLoggedInUser.role !== 'Deliverer' &&
                getLoggedInUser.role !== 'Sewer' &&
                getLoggedInUser.role !== 'Trainee' &&
                getLoggedInUser.role !== 'PatternMaker' &&
                getLoggedInUser.role !== 'StockManager' &&
                getLoggedInUser.role !== 'OnlineSales' &&
                getLoggedInUser.role !== 'Designer' &&
                getLoggedInUser.role !== 'SalesPerson' &&
                getLoggedInUser.role !== 'Receptionist' &&
                getLoggedInUser.role !== 'Accountant' &&
                getLoggedInUser.role !== 'Security' &&
                getLoggedInUser.role !== 'Chauffer' &&
                getLoggedInUser.role !== 'CleaningPerson' &&
                getLoggedInUser.role !== 'HR' &&
                getLoggedInUser.role !== 'HRFinance' &&
                getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                getLoggedInUser.role !== 'Deliverer' &&
                getLoggedInUser.role !== 'TeamLeaderPattern' &&
                getLoggedInUser.role !== 'Procurement'
            "
            button
          >
            <router-link
              to="/suppliers"
              @click.native="clickLink"
            >
              <img
                src="@/assets/images/supplier.svg"
                alt="test"
              >

              <p>{{ $t("Suppliers") }}</p>
            </router-link>
          </b-list-group-item>

          <b-list-group-item
            v-if="
              getLoggedInUser.role == 'hellotest' &&
                getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                getLoggedInUser.role !== 'Procurement'
            "
            button
          >
            <router-link
              to="/history-production"
              @click.native="clickLink"
            >
              <img
                src="@/assets/images/8. History of Production (1).svg"
                alt="test"
              >
              <p>{{ $t("HistoryOfProduction") }}</p>
            </router-link>
          </b-list-group-item>
          <b-list-group-item
            v-if="
              getLoggedInUser.role == 'Admin' || getLoggedInUser.role == 'Receptionist' || getLoggedInUser.role == 'CEO' || getLoggedInUser.role == 'Accountant' || getLoggedInUser.role == 'HR' || getLoggedInUser.role == 'Procurement' || (getLoggedInUser.role == 'SalesPerson' && client == 'DrenushaXharra')
            "
            v-b-toggle.collapse-5
            button
          >
            <router-link
              to="/clients-dashboard"
              :class="{ 'active' : $route.path === '/clients' || $route.path === '/campaign'}"
            >
              <img
                src="@/assets/images/clients.svg"
                alt="test"
              >
              <p>{{ $t("Clients") }}</p>
            </router-link>
            <div class="collapse-icon">
              <b-icon-chevron-down />
            </div>
          </b-list-group-item>
          <b-collapse
            id="collapse-5"
            class="mt-2"
            accordion="my-accordion"
          >
            <b-list-group-item
              v-if="
                getLoggedInUser.role == 'Admin' || getLoggedInUser.role == 'Manager' || getLoggedInUser.role == 'Receptionist' || getLoggedInUser.role == 'CEO' || getLoggedInUser.role == 'Accountant' || getLoggedInUser.role == 'HR' || getLoggedInUser.role == 'Procurement' || (getLoggedInUser.role == 'SalesPerson' && client == 'DrenushaXharra')
              "
              button
            >
              <router-link
                to="/clients"
                @click.native="clickLink"
              >
                <p>{{ $t("ClientsManagement") }}</p>
              </router-link>
            </b-list-group-item>
            <b-list-group-item
              v-if="
                getLoggedInUser.role == 'Admin' || getLoggedInUser.role == 'Manager' || getLoggedInUser.role == 'Receptionist' || getLoggedInUser.role == 'CEO' || getLoggedInUser.role == 'Procurement' || (getLoggedInUser.role == 'SalesPerson' && client == 'DrenushaXharra')
              "
              button
            >
              <router-link
                to="/campaign"
                @click.native="clickLink"
              >
                <p>{{ $t("Campaign") }}</p>
              </router-link>
            </b-list-group-item>
          </b-collapse>
          <b-list-group-item
            v-if="
              getLoggedInUser.role !== 'Deliverer' &&
                getLoggedInUser.role !== 'Sewer' &&
                getLoggedInUser.role !== 'Trainee' &&
                getLoggedInUser.role !== 'PatternMaker' &&
                getLoggedInUser.role !== 'StockManager' &&
                getLoggedInUser.role !== 'OnlineSales' &&
                getLoggedInUser.role !== 'Designer' &&
                getLoggedInUser.role !== 'SalesPerson' &&
                getLoggedInUser.role !== 'Receptionist' &&
                getLoggedInUser.role !== 'Accountant' &&
                getLoggedInUser.role !== 'Security' &&
                getLoggedInUser.role !== 'Chauffer' &&
                getLoggedInUser.role !== 'CleaningPerson' &&
                getLoggedInUser.role !== 'HR' &&
                getLoggedInUser.role !== 'HRFinance' &&
                getLoggedInUser.role !== 'StockManagerMaterialAndProduct' &&
                getLoggedInUser.role !== 'StockManagerMaterialVariant' &&
                getLoggedInUser.role !== 'StockManagerWarehousProductions' &&
                getLoggedInUser.role !== 'Deliverer' &&
                getLoggedInUser.role !== 'TeamLeaderPattern' &&
                getLoggedInUser.role !== 'Procurement'
            "
            button
          >
            <router-link
              to="/analytics"
              @click.native="clickLink"
            >
              <img
                src="@/assets/images/analytics.png"
                width="30px"
                alt="test"
              >

              <p>{{ $t("Analytics") }}</p>
            </router-link>
          </b-list-group-item>
        </b-list-group>
      </div>

      <b-list-group class="settings">
        <b-list-group-item
          v-b-modal.modal-personal-info
        >
          <router-link
            to="/nowhere"
            class="disabled-link"
          >
            <img
              src="@/assets/images/settings.svg"
              width="30px"
              alt="test"
            >
            <p
              style="margin-left: 10px; font-size: 16px; font-weight: 400;"
            >{{ $t("Settings") }}</p>
          </router-link>
        </b-list-group-item>
      </b-list-group>
    </div>
    <Personal />
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { client } from '@/domainConfig'
import Personal from '@/components/personalInfo.vue'


export default {
  components: {
    Personal,
  },
  data() {
    return {
      width: 0,
      client: client.clientName,
      sidebari: null,
    };
  },
  computed: {
    ...mapGetters(['getLoggedInUser', 'getIsSidebarHidden']),
  },
  watch: {
    width(value) {
      // console.log(value);
      if (value <= 1190) {
        this.changeVisibilityOfSidebar(true);
      } else {
        this.changeVisibilityOfSidebar(false);
      }
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapActions([
      'resetDressColors',
      'resetSizes',
      'resetProductsByArticleNumber',
      'resetCreatedOrdersByOrderNumber',
      'changeVisibilityOfSidebar',
      'resetCreatedOrdersByOrderNumberMaterials',
      'resetTotalStockGroupedByLocation',
      'resetInternalMoving',
      'resetReadOrderItems',
      'resetLocationMoving',
      'resetTotalStockGroupedByLocation',
      'resetTotalStockGroupedByLocationDedication',
      'resetHistoryMaterialVariant',
    ]),
    resetBuy() {
      this.resetHistoryMaterialVariant()
    },
    resetInternal() {
      this.resetInternalMoving()
      this.resetReadOrderItems()
      this.resetLocationMoving()
    },
    handleResize() {
      this.width = window.innerWidth;
    },
    resetTotalStock() {
      this.resetTotalStockGroupedByLocation()
      this.resetTotalStockGroupedByLocationDedication()
    },
    clickLink() {
      // this.sidebari = this.$t(name);
      if (this.width <= 1190) {
        this.changeVisibilityOfSidebar(true);
      }
      // this.$emit('sendDataToNavbar', this.sidebari);
    },
    reset() {
      this.resetDressColors();
      this.resetSizes();
      this.resetProductsByArticleNumber();
      this.resetCreatedOrdersByOrderNumberMaterials()
    },
    openScanAndSellModal() {
      this.$nextTick(() => {
        this.$bvModal.show('scan-and-sell');
      });
    },
  },
};
</script>

<style scoped>

.sidebar .list-group-item a.active {
  background-color: rgba(255, 39, 79, 0.1) !important;
  border-left: 3px solid #ff274f !important;
}
.sidebar:hover .image1 {
  display: none !important;
}
.sidebar:hover .image2 {
  display: block !important;
}
.sidebar .image2{
  display:none !important;
}
.sidebar .list-group .collapse .list-group-item a.router-link-active {
    color: #242F6E;
    background-color:rgba(255, 39, 79, 0.1) !important;
    display: none;
  border-left: 3px solid #ff274f !important;

}
.sidebar .list-group .list-group-item a.router-link-exact-active {
    color: #242F6E;
    background-color: rgba(255, 39, 79, 0.1) !important;
    border-left: 3px solid #ff274f !important;
}
.sidebar:hover .collapse .list-group-item a.router-link-active{
    display: flex;
    color: #242F6E;
    background-color: #e8e8e8;
  border-left: 3px solid #ff274f !important;

}
.sidebar .list-group-item .collapse-icon {
    position: absolute;
    right: 25px;
    top: 50%;
    transform: translatey(-50%);
    transition: ease all 0.4s;
    display: none;
}
.sidebar:hover .collapse-icon{
  display: block;
}
.sidebar .list-group .list-group-item p {
  display: none;
}

.sidebar .list-group-item a.active {
  background-color: #e8e8e8;
}

.allButtons{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%
}

.settings{
  border-top: 1px solid #DDE0E5;
  border-radius: 0px;
}

.sidebar {
  display: block !important;
  overflow: hidden;
  width: 5% !important;
  height: 100%;
  transition: width 0.3s ease-in-out;
}

.sidebar:hover .list-group-item p {
  display: block;
  width: 100%;
}

.sidebar:hover {
  width: 17% !important;
  overflow: auto !important;
  height: 100vh;
  transition: width 0.16s; /* Disable transition when hovered */
}
.hide {
  display: none !important;
}
button a p{
  margin-left: 10px;
  font-size: 16px;
  font-weight: 400;
}
.show {
  display: block !important;
}

.side-enter-active,
.side-leave-active {
  transition: transform 0.2s ease;
}

.side-enter,
.side-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s;
}

/* .router-link-active,
  .router-link-exact-active {
    background-color: red;
    color: #fff !important;
  } */

@media screen and (min-width: 1500px) and (max-width: 1700px) {
  .sidebar .list-group .list-group-item a {
    padding: 0.9rem 1.5rem;
  }
}

@media screen and (min-width: 1300px) and (max-width: 1500px) {
  .sidebar .list-group .list-group-item a {
    padding: 0.9rem 1.2rem;
  }
}

@media screen and (max-width: 1300px){
  .sidebar {
    display: none;
    width: 6% !important;
  }
  .sidebar .list-group .list-group-item a {
    padding: 0.9rem 1.2rem;
  }
}

@media only screen and (max-width: 1200px) {
  .sidebar {
    display: none;
    width: 7% !important;
  }
}

@media only screen and (max-width: 1190px) {
  .sidebar .list-group .collapse .list-group-item a.router-link-active {
    color: #242F6E;
    background-color: #e8e8e8;
    display: block;
}
.sidebar:hover .collapse .list-group-item a.router-link-active{
/* display: none; */
color: #242F6E;
    background-color: #e8e8e8;
}
.sidebar .list-group-item .collapse-icon {
    position: absolute;
    right: 25px;
    top: 50%;
    transform: translatey(-50%);
    transition: ease all 0.3s;
    display: block;
}
.sidebar:hover .collapse-icon{
  display: none;
}
.sidebar .list-group .list-group-item p {
  display: block;

}

.sidebar {
  display: block !important;
  overflow: auto;
  width: 25% !important;
  transition: width 0.3s ease;
}

.sidebar:hover .list-group-item p {
  display: block;
  width: 100%;
}

.sidebar:hover {
  width: 25% !important;
  height: 100vh;
  display: none;
}
  .sidebar {
    display: block !important;
  }
}

/* @media screen and (max-width: 767px) {
  .sidebar {
    display: none;
  }
} */
</style>
